<ng-container *ngIf="isCssReady">
  <div
    *ngIf="!data?.isForHub && dialogRef"
    class="transition-all hover:scale-[1.1] fixed top-1 px-3 py-1 flex items-center gap-3 cursor-pointer mobile:top-3"
    (click)="close()"
  >
    <ig-image
      src="https://iti-images.s3.amazonaws.com/imgs/back-arrow.png"
      cls="w-[60px] h-[60px] mobile:w-[50px] mobile:h-[50px]"
    >
    </ig-image>
    <span class="text-xl font-semibold text-white mobile:text-lg">BACK</span>
  </div>

  <div class="create-wrapper flex justify-center items-start relative ig-db-theme-green">
    <mat-icon
      *ngIf="data?.isForHub"
      class="absolute top-4 right-4 text-gray-500 text-[18px] bg-gray-200 hover:bg-gray-300 flex items-center justify-center !w-7 !h-7 rounded-full cursor-pointer transition-all"
      (click)="close()"
    >
      close
    </mat-icon>

    <div
      class="h-full flex shadow-2xl max-w-[1400px] mobile:block mobile:w-full mobile:h-full mobile:overflow-y-auto mobile:overflow-x-hidden"
      [class.w-full]="frontendSettings.customSettings.menuStyle.isSideBar"
      [class.mx-6]="frontendSettings.customSettings.menuStyle.isSideBar"
      [class.w-[80%]]="!frontendSettings.customSettings.menuStyle.isSideBar"
      [class.!w-full]="data?.isForHub"
    >
      <section *ngIf="!data?.isForHub" class="left-wrapper !w-1/3 relative hidden xl:block">
        <div class="w-full h-full bg-black opacity-30 absolute"></div>
        <div
          class="w-full h-full absolute text-white text-center pt-20 flex flex-col justify-between"
        >
          <div>
            <div class="text-3xl font-semibold">Welcome</div>
            <div class="text-base mt-4 2xl:text-lg">Thank you for submitting your events</div>
          </div>

          <div class="mb-24 mx-auto w-[90%] text-left">
            <div class="flex items-center justify-start">
              <span class="text-3xl mr-2 leading-6">·</span>
              <span class="text-xs 2xl:text-sm">
                Please fill in your event info on the right side
              </span>
            </div>
            <div class="flex items-center justify-center">
              <span class="text-3xl mr-2 leading-6">·</span>
              <span class="text-xs 2xl:text-sm">
                Please wait at least 5 business days for approval after submitting your event
              </span>
            </div>
          </div>
        </div>
      </section>

      <div
        class="w-full bg-white rounded-r-2xl pl-9 pr-4 py-6 text-gray-600 xl:w-2/3 mobile:px-6 mobile:pb-16"
        [class.!w-full]="data?.isForHub"
      >
        <div class="text-2xl">Please fill in your event info</div>
        <div class="text-sm text-gray-400">
          Complete all required fields marked with an *
          <span *ngIf="!data?.isForHub">to submit your event for approval</span>
        </div>

        <section class="form-scroll-section w-full mt-4 py-2 h-[calc(100%-4rem)] overflow-y-auto pr-5 mobile:pr-0">
          <ig-field [control]="form.get('name')" label="Title" icon="stars"></ig-field>
          <ig-field [control]="form.get('host')" label="Host" icon="person"></ig-field>
          <ig-field
            [control]="form.get('venue')"
            label="Location / Venue Name"
            icon="location_city"
          ></ig-field>

          <!-- Location / Address with helper text -->
          <div
            class="address-field-wrapper mobile:mb-6"
            [class.address-field-invalid]="
              form.get('address').invalid && form.get('address').touched
            "
          >
            <ig-address-input
              #addressInput
              [control]="form.get('address')"
              class="block"
              [label]="'Location / Address *'"
            >
            </ig-address-input>

            <p class="address-helper-text text-sm text-gray-600 mb-0 mt-0 flex items-center gap-1">
              Please type the street address and select the correct address from the drop-down.
              <mat-icon
                class="!text-base !w-4 text-gray-400 cursor-help"
                matTooltip="Type a street address in the field above. A dropdown will appear with Google Maps suggestions. You must click on the correct address from the dropdown to select it. Manually typed addresses are not accepted."
              >help_outline</mat-icon>
            </p>
          </div>

          <div class="flex gap-4 mb-1">
            <mat-checkbox
              *ngIf="frontendSettings.customSettings.isAllowOnlineEvents"
              class="text-gray-400"
              (change)="onlineEventChange($event)"
              [checked]="!!form.get('isOnlineEvent').value"
              matTooltip="Virtual events (online events) don't have physical addresses"
            >
              Virtual Event
            </mat-checkbox>
            <mat-checkbox
              class="example-margin"
              (change)="hybridChange($event)"
              [checked]="!!form.get('isHybridEvent').value"
              matTooltip="Hybrid events are both virtual and in-person"
            >
              Hybrid Event
            </mat-checkbox>
          </div>

          <ig-field
            [control]="form.get('organizerEmail')"
            label="Event Organizer Email Address"
            icon="mail"
          >
          </ig-field>
          <ig-field
            [control]="form.get('eventLink')"
            label="Event URL for more information (if applicable)"
            icon="link"
          >
          </ig-field>
          <ig-field [control]="form.get('hostLink')" label="Event Host Website URL" icon="link">
          </ig-field>
          <ig-field
            [control]="form.get('ticketUri')"
            label="Get Tickets URL (if applicable)"
            icon="receipt"
          >
          </ig-field>
          <div
            class="description-field-wrapper mb-6"
            [class.description-field-invalid]="
              form.get('description').invalid && form.get('description').touched
            "
            (keydown.space)="$event.stopPropagation()"
          >
            <div class="description-label text-gray-600 mb-1">Description*</div>
            <ig-rich-text-box
              #richTextBox
              (descriptionChange)="onDescriptionChange($event)"
              (editorBlur)="form.get('description').markAsTouched()"
            >
            </ig-rich-text-box>
            <p
              *ngIf="form.get('description').invalid && form.get('description').touched"
              class="description-error text-sm mt-1 mb-0"
            >
              Please provide a description for your event.
            </p>
          </div>

          <div *ngIf="frontendSettings">
            <ig-event-frequency-picker
              #frequencyPicker
              [formControl]="recurrenceControl"
              [timezoneFormatter]="frontendSettings.customSettings.timezoneFormatter"
              [timezone]="timeService.getTZByFormatter(frontendSettings.customSettings.timezoneFormatter)"
            >
            </ig-event-frequency-picker>
          </div>

          <ig-image-link-file-selector #imgUploader></ig-image-link-file-selector>

          <mat-checkbox
            *ngIf="data?.isForHub"
            class="!block text-gray-500 -translate-y-3"
            (change)="setAsApprovedChange($event)"
          >
            Set as Approved
          </mat-checkbox>

          <div
            *ngIf="pendingDuplicates?.length"
            class="duplicate-warning mb-6 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950"
            role="alert"
          >
            <div class="font-semibold mb-2">Possible duplicate event found</div>
            <p class="mb-3 text-amber-900">
              An event with a similar title, date, and location already exists. Review the match below, or create this listing anyway.
            </p>
            <ul class="mb-4 list-disc pl-5 space-y-1">
              <li *ngFor="let match of pendingDuplicates">
                {{ duplicateMatchLabel(match) }}
                <span *ngIf="match.reasons?.length" class="block text-xs text-amber-800">
                  {{ match.reasons.join(' · ') }}
                </span>
              </li>
            </ul>
            <div class="flex flex-wrap gap-3">
              <ig-button mode="flat" cls="min-w-[120px]" (trigger)="onDismissDuplicateWarning($event)">
                Cancel
              </ig-button>
              <ig-button
                theme
                cls="min-w-[160px]"
                [isAsync]="true"
                (trigger)="createDespiteDuplicates($event)"
              >
                Create anyway
              </ig-button>
            </div>
          </div>

          <ig-button
            *ngIf="(!hasSubmittedSuccessfully || data?.isForHub) && !pendingDuplicates?.length"
            theme
            (trigger)="submit($event)"
            cls="w-[160px] mb-6 mobile:w-full"
            [isAsync]="true"
            [disabled]="isFormInValid"
            [successText]="data?.isForHub ? 'Event created successfully!' : ''"
          >
            SUBMIT EVENT
          </ig-button>

          <div
            *ngIf="hasSubmittedSuccessfully && !data?.isForHub"
            #submitSuccessBanner
            class="submit-success-banner submit-success-banner--inline mb-6"
            aria-live="polite"
          >
            <div class="submit-success-banner__icon">
              <mat-icon>check_circle</mat-icon>
            </div>
            <div class="submit-success-banner__content">
              <div class="submit-success-banner__title">Event submitted successfully</div>
              <p class="submit-success-banner__message mb-0">
                {{ submitSuccessMessage }}
              </p>
              <ig-button
                cls="submit-success-banner__action mt-4 mobile:w-full"
                mode="flat"
                (trigger)="submitAnotherListing()"
              >
                Submit Another Listing
              </ig-button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</ng-container>
